export default __webpack_public_path__ + "static/media/SparkleTop.79c8f5a2.svg";